// extracted by mini-css-extract-plugin
module.exports = {"link":"footer_link__2MkVR","icon":"footer_icon__erQq4","footerLinks":"footer_footerLinks__3fgmY"};